import { useState, useEffect } from "react";

/**
 * Returns the current text color from --bs-body-color CSS variable.
 * Reacts to dark mode toggle (base-theme attribute on <body>).
 */
export function useChartTextColor(): string {
  const [color, setColor] = useState(() => getTextColor());

  useEffect(() => {
    const observer = new MutationObserver(() => setColor(getTextColor()));
    observer.observe(document.body, { attributes: true, attributeFilter: ["base-theme"] });
    return () => observer.disconnect();
  }, []);

  return color;
}

function getTextColor(): string {
  return getComputedStyle(document.body).getPropertyValue("--bs-body-color").trim() || "#333";
}
